/* eslint-disable no-restricted-syntax */
const headerEl = document.querySelector('header');

if (headerEl && headerEl.classList.contains('show-booking-search')) {
	const targetNode = headerEl.querySelector('#booking-header-search');
	const mutationConfig = { childList: true, attributes: true, subtree: true };

	const observer = new MutationObserver((mutationsList) => {
		if (headerEl.classList.contains('query-view') || headerEl.classList.contains('search-view')) {
			observer.disconnect();
		}
		for (const mutation of mutationsList) {
			if (mutation.type === 'attributes') {
				const bookingWidgetEl = targetNode.childNodes[0];
				if (bookingWidgetEl) {
					const searchView = bookingWidgetEl.getAttribute('data-search-view');
					if (searchView) {
						headerEl.classList.add(searchView === 'query' ? 'query-view' : 'search-view');
					}
				}
			}
		}
	});
	observer.observe(targetNode, mutationConfig);
}
